import {PropsWithChildren} from 'react'
import {GlobalContext} from '../GlobalContext'

export interface GlobalProps {
    layout: string
}

export const GlobalContextProvider = (props: PropsWithChildren<GlobalProps>) => {
    const kind: string = props.layout

    return <GlobalContext.Provider value={{layout: kind}}>{props.children}</GlobalContext.Provider>
}
